import { List, useGetList, useGetOne, useRecordContext } from "react-admin";
import { Instructor } from "../../providers/instructorsProvider";
import { StudentsDataGrid } from "../../lists/StudentsDataGrid";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { EmptyState } from "../../misc/EmptyState";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { grants } from "../../backoffice.access_control";
import { Row } from "../../misc/Row";
import { SearchFilterInput } from "../../inputs/SearchFilterInput";

export function InstructorStudentsList() {
  const instructor = useRecordContext<Instructor>();
  const drivingSchoolId = instructor?.drivingSchoolId;
  const { data: drivingSchool } = useGetOne<DrivingSchool>(
    "drivingSchools",
    { id: drivingSchoolId },
    { enabled: !!drivingSchoolId },
  );
  const { data: simulators } = useGetList(
    "simulators",
    {
      filter: { drivingSchoolId },
      pagination: { page: 1, perPage: 2 },
      sort: { field: "id", order: "DESC" },
    },
    {
      enabled: !!drivingSchoolId,
    },
  );
  const showSimulatorDrivingLessons = !!simulators?.length;

  if (!(instructor && drivingSchool && simulators)) {
    return <LoadingIndicator />;
  }

  return (
    <ResponsiveListSurface variant="compactStandalone" data-testid="InstructorStudentsList">
      <List
        resource="students"
        storeKey={`instructorStudents@${instructor.id}`}
        title=" " // <-- prevent that the default list title is rendered
        filter={{ instructorIds: [instructor.id], status: ["active", "onHold", "outstandingPayments"] }}
        filters={[<SearchFilterInput key="q" source="q" alwaysOn resettable />]}
        sort={/* initial sort order: */ { field: "name", order: "ASC" }}
        empty={<EmptyState />}
        exporter={false}
        actions={grants.has("Student:ShowCreateButton") ? <InstructorStudentsListActions /> : false}
        sx={{ "& .RaList-main > .RaList-actions": { mt: { sm: "-5px" }, width: "100%" } }}
      >
        <StudentsDataGrid drivingSchool={drivingSchool} showSimulatorDrivingLessons={showSimulatorDrivingLessons} />
      </List>
    </ResponsiveListSurface>
  );
}

function InstructorStudentsListActions() {
  const navigate = useNavigate();
  const createStudent = () => navigate("/students/create");

  return (
    <Row sx={{ alignItems: "center", justifyContent: "flex-end", mb: 1, mt: { xs: "8px", sm: "19px" } }}>
      <IconButton
        aria-label="Fahrschüler erstellen"
        onClick={createStudent}
        sx={{ display: { xs: "inline-flex", sm: "none" } }}
      >
        <AddIcon />
      </IconButton>
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={createStudent}
        size="small"
        sx={{ display: { xs: "none", sm: "inline-flex" } }}
      >
        Erstellen
      </Button>
    </Row>
  );
}
